import { JsonPipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { GlobalVariable } from 'src/app/config/service.config';
import { Contact } from 'src/app/models/contact.model';
import { ContratoecertService } from 'src/app/services/contratoecert.service';
import { FaseService } from 'src/app/services/fase.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
//import { EsignService } from 'src/app/services/esign.service';
import { AuthService } from 'src/app/services/auth.service';
//import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;

@Component({
  selector: 'app-contratoecert',
  templateUrl: './contratoecert.component.html',
  styleUrls: ['./contratoecert.component.css']
})
export class ContratoecertComponent implements OnInit, OnDestroy {
  @Output() Fase: EventEmitter<string> = new EventEmitter();
  contratoForm: FormGroup;
  urls = GlobalVariable.API_CloudSigner;
  @Input() IdProceso: string = '';
  @Input() Alumno: Contact;
  @Input() faseActual: string;
  @Input() ultimafase: number;
  contratoSubcribe: Subscription;

  inforamar = false;
  trx = '';//Documento
  rut = ''; //RUT SIN - Guion
  rutapoderado = ''; //RUT SIN - Guion
  titulo = 'Validando Firma Digital';
  body = 'Por favor, espera mientras se genera la verificación de la firma digital.';
  InternalEstado = 0;
  EstadoAlerta = '0';
  progress = false;
  iframe = false;
  url: string = ''
  urlSafe: SafeResourceUrl;
  openContrato = false;
  cargandoClave = true;
  portalName = "centralizado";

  // TODO: TEST
  // urlIframeRechazoContrato: SafeResourceUrl = '';
  user: any;

  constructor(public sanitizer: DomSanitizer,
    private contratoecertservice: ContratoecertService,
    private route: ActivatedRoute,
    //private esign: EsignService,
    private fb: FormBuilder,
    private faseService: ProcesoMatriculaService,
    public faseSubcribe: FaseService,
    private alerts: ToastrService,
    private auths: AuthService) {
    this.contratoForm = fb.group({
      TrazabilidadFirmaECert: [false],
      PreinscribirECert: [false],
      FirmaDocumentoTRX: [false],
      ContratoUST: [false],
      SubirDocumentoECert: [false],
      VisualizarContrato: [false]
      // Firmantes: [false],
      // UsuarioEnrolado: [false],
      // GeneracionContrato: [false],
      // BusquedaContrato: [false],
      // EstadoContrato: [false]
    });
    debugger;
    //Obtener Id Proceso Matricula parametros
    this.route.params.subscribe(params => {
      if (params.id !== '' || params.id !== undefined) {
        this.IdProceso = `${params.id}`;
      }
    });
    //
    this.contratoSubcribe = this.faseSubcribe.fase$.subscribe(
      value => {
         debugger;
        if (value == '5') {
          if (this.ultimafase > 5) {
            this.validarTrazabilidadFirma();
            //TODO: Validar el estado del contrato
            // this.contratoecertservice.getEstadoContrato(this.IdProceso).subscribe(
            //   (data: any) => {
            //     if (data.RetornoDesdeApi != null) {
            //       if (data.RetornoDesdeApi[0].estado_firma === '3') {
            //         // cuando el estado es 3 quiere decir que ya se firmo el documento
            //         this.Fase.emit('6');
            //         this.faseSubcribe.fase$.emit('6');
            //       } else {
            //         this.titulo = 'Información';
            //         this.body = 'Para avanzar de fase debe firmar el contrato';
            //         this.progress = false;
            //         this.goToBottomDiv();
            //       }
            //     } else {
            //       this.titulo = 'Información';
            //       this.body = 'Para avanzar de fase debe firmar el contrato';
            //       this.progress = false;
            //       this.goToBottomDiv();
            //     }
            //   },
            //   (err) => { }
            // );
          }
        }
      }
    );
  }
  ngOnDestroy(): void {
    this.contratoSubcribe.unsubscribe();
  }
  ngOnInit(): void {
    // TODO: TEST
    debugger; 
    this.user = this.auths.GetUserToken();
    this.validarTrazabilidadFirma();
  }
  proceso() {
    this.inforamar = true;
    switch (this.InternalEstado) {
      case 0:
        // PreInscribir Alumno
        debugger;
        this.PreinscribirECert();
        break;
      case 1: 
        // obtener TRX contrato
        debugger;
        this.getUSTFirmaDocumentoTRX();
        break;
      case 2: 
        // Generar Documento 
        debugger;
        this.getContratoUST();
        break;
      case 3:
        //Subir Documento
        debugger;
        this.SubirDocumentoECert();
        break;
      case 4:
        //Visualizar Contrato
        debugger;
        this.VisualizarContrato();
        break;
      // case 5:
        //Subir Documento
        //this.SubirDocumentoECert();
        // break;
      default:
        break;
    }
    // switch (this.InternalEstado) {
    //   case 0:// Validando los firmantes
    //     this.ValidarFirmantes();
    //     // PreInscripcion
    //     break;
    //   case 1: //Validar enrolamiento del usuario
    //     this.ValidarEnrolamiento();
    //     // obtener TRX contrato
    //     break;
    //   case 2: // CRM ver si tiene contrato
    //     this.GeneraContrato();
    //     // Generar Documento 
    //     break;
    //   case 3:
    //     this.BuscarNombreDocumento();
    //     break;
    //   case 4:
    //     this.validarEstadoDocuemnto();
    //     break;

    //   default:
    //     break;
    // }
  }

  validarTrazabilidadFirma() {
    this.titulo = 'Estado del contrato';
    this.body = 'Validando el estado del contrato';
    this.progress = true;
    this.contratoecertservice.getTrazabilidadFirmaECert(this.IdProceso).subscribe(
      (data: any) => {
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            // cuando el estado es 1 quiere decir que ya se firmo el contrato
            this.Fase.emit('6');
            this.faseSubcribe.fase$.emit('6');
          } 
          else if (data.Codigo === 2){
            this.contratoForm.controls.TrazabilidadFirmaECert.setValue(true);
            this.titulo = 'Información';
            this.body = data.Mensaje;
            this.progress = false;
            this.goToBottomDiv();
          }
          else 
          {
            this.contratoForm.controls.TrazabilidadFirmaECert.setValue(true);
            this.titulo = 'Información';
            this.body = 'Para avanzar de fase debe firmar el contrato';
            this.progress = false;
            this.goToBottomDiv();
          }
        } else {
          this.contratoForm.controls.TrazabilidadFirmaECert.setValue(true);
          this.titulo = 'Información';
          this.body = 'Para avanzar de fase debe firmar el contrato';
          this.progress = false;
          this.goToBottomDiv();
        }
      },
      (err) => { }
    );
    // this.contratoecertservice.getEstadoContrato(this.IdProceso).subscribe(
    //   (data: any) => {
    //     if (data.RetornoDesdeApi[0].estado_firma === '3') {
    //       this.titulo = 'Contrato';
    //       this.body = 'Estado del contrato ' + this.parcharGlosaEstadoFirma(data.RetornoDesdeApi[0].glosa_estado_firma);
    //       this.OpenContrato();
    //     }
    //     if (data.RetornoDesdeApi[0].estado_firma === '5') {
    //       this.titulo = 'Contrato';
    //       this.body = 'Estado del contrato ' + this.parcharGlosaEstadoFirma(data.RetornoDesdeApi[0].glosa_estado_firma);
    //       this.OpenContrato();
    //       this.progress = true;
    //     }
    //     this.contratoForm.controls.EstadoContrato.setValue(true);
    //     this.progress = false;
    //   },
    //   (err) => {
    //     this.progress = false;
    //   },
    //   () => { }
    // );
  }

  // parcharGlosaEstadoFirma(glosa: string): string {
  //   if (glosa.toLowerCase() === 'en_curso')
  //     return 'En curso'
  //   return glosa
  // }

  SolicitarContrato() {
    this.progress = true;
    this.InternalEstado = 0;
    this.contratoForm.controls.PreinscribirECert.setValue(false);
    this.contratoForm.controls.FirmaDocumentoTRX.setValue(false);
    this.contratoForm.controls.ContratoUST.setValue(false);
    this.contratoForm.controls.SubirDocumentoECert.setValue(false);
    this.contratoForm.controls.VisualizarContrato.setValue(false);
    this.proceso();
  }

  PreinscribirECert() {
    this.titulo = 'Preinscribir firmante Proveedor E-Cert';
    this.body = 'Preinscribir firmantes de contrato...';
    this.progress = true;

    this.contratoecertservice.PreinscribirECert(this.IdProceso, this.portalName).subscribe(
      (data: any) => {
        this.body = 'Preinscribir firmante...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            this.contratoForm.controls.PreinscribirECert.setValue(true);
            this.InternalEstado = 1;
            this.proceso();
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
        // this.rut = data.Result?.AlumnoRut;
        // this.rutapoderado = data.Result?.ApoderadoRut;
        // this.trx = data.Result?.NombreDocumento;
        //alert(JSON.stringify(data));
        // if (this.rut !== '') {
        //   this.contratoForm.controls.Firmantes.setValue(true);
        //   this.InternalEstado = 1;
        //   this.proceso();
        // } else {
        //   this.progress = false;
        // }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );
  }

  getUSTFirmaDocumentoTRX(){
    this.titulo = 'Obteniendo TRX Firma Documento UST';
    this.body = 'Obtener TRX Firma Documento ...';
    this.progress = true;
    this.contratoecertservice.getUSTFirmaDocumentoTRX(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'TRX Firma Documento UST...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            this.contratoForm.controls.FirmaDocumentoTRX.setValue(true);
            this.InternalEstado = 2;
            this.proceso();
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
        // this.rut = data.Result?.AlumnoRut;
        // this.rutapoderado = data.Result?.ApoderadoRut;
        // this.trx = data.Result?.NombreDocumento;
        //alert(JSON.stringify(data));
        // if (this.rut !== '') {
        //   this.contratoForm.controls.Firmantes.setValue(true);
        //   this.InternalEstado = 1;
        //   this.proceso();
        // } else {
        //   this.progress = false;
        // }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );

  }
  
  getContratoUST(){
    this.titulo = 'Generando Contrato UST';
    this.body = 'Generando Documento Contrato UST...';
    this.progress = true;
    this.contratoecertservice.getContratoUST(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'TRX Firma Documento UST...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            this.contratoForm.controls.ContratoUST.setValue(true);
            this.InternalEstado = 3;
            this.proceso();
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
        // this.rut = data.Result?.AlumnoRut;
        // this.rutapoderado = data.Result?.ApoderadoRut;
        // this.trx = data.Result?.NombreDocumento;
        //alert(JSON.stringify(data));
        // if (this.rut !== '') {
        //   this.contratoForm.controls.Firmantes.setValue(true);
        //   this.InternalEstado = 1;
        //   this.proceso();
        // } else {
        //   this.progress = false;
        // }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );
  }

  SubirDocumentoECert(){
    this.titulo = 'Subir Documento Proveedor E-Cert';
    this.body = 'Subiendo Documento Contrato Proveedor E-Cert...';
    this.progress = true;
    this.contratoecertservice.SubirDocumentoECert(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'Subir Documento...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            this.contratoForm.controls.SubirDocumentoECert.setValue(true);
            this.InternalEstado = 4;
            this.proceso();
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
        // this.rut = data.Result?.AlumnoRut;
        // this.rutapoderado = data.Result?.ApoderadoRut;
        // this.trx = data.Result?.NombreDocumento;
        //alert(JSON.stringify(data));
        // if (this.rut !== '') {
        //   this.contratoForm.controls.Firmantes.setValue(true);
        //   this.InternalEstado = 1;
        //   this.proceso();
        // } else {
        //   this.progress = false;
        // }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );
  }

  VisualizarContrato(){
    debugger;
    this.titulo = 'Generando contrato';
    this.body = 'Esperar mientra se genera la documentacion para el contrato';
    this.progress = true;

    this.contratoecertservice.VisualizarContrato(this.IdProceso).subscribe(
      (data: any) => {
        debugger;
        if (data.Codigo !== 1) {
          this.titulo = 'Advertencia';
          this.body = "El contrato no se puede visualizar, contáctanos a través del chat haciendo click en el ícono más abajo.";
          this.progress = false;
          this.EstadoAlerta = '1';
          return;
        }
        else 
        {
          debugger;
          this.contratoForm.controls.VisualizarContrato.setValue(true);
          this.goToBottomDiv();
          this.progress = true;
          this.openContrato = true;
          this.titulo = data.DocB64 == '' ? 'Sin contrato' : this.titulo;
          this.body = data.DocB64 == '' ? 'Notificar a info@santotomas.cl, para la generacion del contrato' : this.body;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data.DocB64);
          //this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${image}`);
          this.iframe = true;
          this.progress = false;
        }
        

        //this.contratoForm.controls.GeneracionContrato.setValue(true);
        //this.InternalEstado = 3;
        //this.proceso();
        
      },
      (err) => {
        this.progress = false;
      }
    )

  }

  RedireccionarECert(){
   debugger;
    this.titulo = 'Redireccionando Proveedor E-Cert';
    this.body = 'Redireccionando al Proveedor E-Cert para firma de documento...';
    this.progress = true;
    this.contratoecertservice.RedireccionarECert(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'Redireccionando Proveedor E-Cert...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            //this.contratoForm.controls.SubirDocumentoECert.setValue(true);
            //this.InternalEstado = 4;
            let url = data.URLProveedorECert;
            window.location.href = url;
            //this.proceso();
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );

  }

  CadurarPreinscripcion(){
    this.titulo = 'Caducar Preinscripción Proveedor E-Cert';
    this.body = 'Caducar Preinscripción Proveedor E-Cert...';
    this.progress = true;
    this.contratoecertservice.CaducarPreinscripcionECert(this.IdProceso).subscribe(
      (data: any) => {
        this.body = 'Caducar Preinscripción...';
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            //this.contratoForm.controls.SubirDocumentoECert.setValue(true);
            //this.InternalEstado = 4;
            // al caducar se debe enviar inicio del sitio
            //this.proceso();
            window.location.href = "/inicio";
          }else {
            this.progress = false;
            this.body = data.Mensaje;
          }
        }else {
          this.progress = false;
          this.body = 'Se ha pedido la comunicacion del sitioweb.';
        }
      },
      (err) => {
        this.progress = false;
        this.body = 'Se ha pedido la comunicacion del sitioweb.';
      }
    );
  }


  // OpenContrato() {
  //   this.progress = true;
  //   this.openContrato = true;
  //   this.titulo = this.trx == '' ? 'Sin contrato' : this.titulo;
  //   this.body = this.trx == '' ? 'Notificar a info@santotomas.cl, para la generacion del contrato' : this.body;
  //   //TODO: Validar con cloud sign como enviar el rut del apoderado o si no es neceario enviarlo y el iframe se encargará de solicitar la firma de ambos firmantes
  //   if (this.rutapoderado !== '') {
  //     this.url = `${this.urls}firmar_documento_secuencial.php?trx=${this.trx}&ruts=${this.rut},${this.rutapoderado}&huella=0`;
  //     console.log("URL Contrato: " + this.url);
  //   }
  //   else
  //     this.url = `${this.urls}firmar_documento_secuencial.php?trx=${this.trx}&ruts=${this.rut}&huella=0`;

  //   this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  //   this.iframe = true;
  //   this.progress = false;
  // }

  

  // ValidarFirmantes() {
  //   this.titulo = 'Validando los Firmantes';
  //   this.body = 'Buscando firmantes de contrato...';
  //   this.progress = true;
  //   // this.contratoecertservice.getNombreDocumento(this.IdProceso).subscribe(
  //   //   (data: any) => {
  //   //     //this.progress = false;
  //   //     this.body = 'Procesando firmantes...';
  //   //     this.rut = data.Result?.AlumnoRut;
  //   //     this.rutapoderado = data.Result?.ApoderadoRut;
  //   //     this.trx = data.Result?.NombreDocumento;
  //   //     //alert(JSON.stringify(data));
  //   //     if (this.rut !== '') {
  //   //       this.contratoForm.controls.Firmantes.setValue(true);
  //   //       this.InternalEstado = 1;
  //   //       this.proceso();
  //   //     } else {
  //   //       this.progress = false;
  //   //     }
  //   //   },
  //   //   (err) => {
  //   //     this.progress = false;
  //   //     this.body = 'Se ha pedido la comunicacion del sitioweb.';
  //   //   }
  //   // );
  // }

  // BuscarNombreDocumento() {
  //   this.progress = true;
  //   // this.contratoecertservice.getNombreDocumento(this.IdProceso).subscribe(
  //   //   (data: any) => {
  //   //     this.trx = data.Result?.NombreDocumento;

  //   //     if (this.trx !== '') {
  //   //       this.contratoForm.controls.BusquedaContrato.setValue(true);
  //   //       this.InternalEstado = 4;
  //   //       this.proceso()
  //   //     } else {
  //   //       this.progress = false;
  //   //     }
  //   //   },
  //   //   (err) => {
  //   //     this.progress = false;
  //   //     this.titulo = 'Se ha pedido la comunicacion del sitioweb.'
  //   //   }
  //   // );
  // }

  // GeneraContrato() {
  //   //Generando contrato
  //   this.titulo = 'Generando contrato';
  //   this.body = 'Esperar mientra se genera la documentacion para el contrato';
  //   this.progress = true;
  //   // this.contratoecertservice.crearContra(this.rut, this.IdProceso).subscribe(
  //   //   (data: any) => {
  //   //     if (data.Codigo == 14) {
  //   //       this.titulo = 'Advertencia';
  //   //       this.body = "El contrato no se puede visualizar, contáctanos a través del chat haciendo click en el ícono más abajo.";
  //   //       this.progress = false;
  //   //       this.EstadoAlerta = '1';
  //   //       return;
  //   //     }

  //   //     this.goToBottomDiv();
  //   //     //this.progress = false;
  //   //     this.contratoForm.controls.GeneracionContrato.setValue(true);
  //   //     // if (data.Result?.Codigo === '1') {
  //   //     this.InternalEstado = 3;
  //   //     this.proceso();
  //   //     // }
  //   //   },
  //   //   (err) => {
  //   //     this.progress = false;
  //   //   }
  //   // )
  // }

  goToBottomDiv() {
    const waitMillisecondsUntilFocus = 300;
    setTimeout(() => {
      try { $('html, body').animate({ scrollTop: $('#divBottom').offset().top }, 'slow'); } catch { }
    }, waitMillisecondsUntilFocus);
  }

  avanceFase() {
    if (this.faseActual !== '5') {
      return;
    }
    this.progress = true;
    this.inforamar = true;
    this.titulo = 'Evaluando estado de firma de contrato';
    this.body = 'Esperar...';
    this.contratoecertservice.getTrazabilidadFirmaECert(this.IdProceso).subscribe(
      (data: any) => {
        debugger;
        if (data.Codigo != null) {
          if (data.Codigo === 1) {
            if (this.faseActual === '5') {
              this.faseService.setFase(this.IdProceso, '6').subscribe(
                (dt) => {
                  // this.progress = false;
                  this.Fase.emit('6');
                  this.faseSubcribe.fase$.emit('6');
                },
                (err) => {
                  this.titulo = 'Información';
                  this.body = 'Error al avanzar de fase. Contacte a un usuario de soporte de Santo Tomás';
                  this.progress = false;
                  this.goToBottomDiv();
                }
              );
            }
          } else {
            this.titulo = 'Información';
            this.body = 'Para avanzar de fase debe firmar el contrato';
            this.progress = false;
            this.goToBottomDiv();
          }
        } else {
          this.titulo = 'Información';
          this.body = 'Para avanzar de fase debe firmar el contrato';
          this.progress = false;
          this.goToBottomDiv();
        }

      },
      (err) => {
        this.titulo = 'Información';
        this.body = 'Error al avanzar de fase. Contacte a un usuario de soporte de Santo Tomás';
        this.progress = false;
        this.goToBottomDiv();
      }
    );
  }

  // openModalInfoESign() {
  //   $('#infoCorreoESign').modal('show');
  // }

  // esignInit() {
  //   this.progress = true;
  //   this.InternalEstado = 0;
  //   // this.esign.CrearUsuario(this.Alumno.Rut, this.IdProceso).subscribe(
  //   //   (data) => {
  //   //     console.log('[ESING - Resultado de Crear usuario]', data)
  //   //     this.esign.CrearApoderado(this.IdProceso).subscribe(
  //   //       (res) => {
  //   //         this.cargandoClave = false;
  //   //         this.progress = false;
  //   //         console.log('[ESING - Resultado de Crear apoderado]', res);
  //   //         this.openModalInfoESign();
  //   //       }
  //   //     )
  //   //   }
  //   // )
  // }
}
